import * as yup from 'yup'

export class VehicleBondInformationDto {
  bondNumber?: string = undefined
  specialBondNumber?: string = undefined
  amountUSD?: number = undefined
  bondThreshold?: number = undefined
  amountUSD150Percent?: number = undefined
}

export const vehicleBondInformationValidationSchema = yup.object({
  specialBondNumber: yup
    .string()
    .max(200, 'Special Bond # cannot be more than 200 characters.')
    .required('Special Bond # is required.')
})
